import { Button } from '@common/components';
import Cookie from 'js-cookie';

import { invalidateSpaPackageTimeslots } from '@features/spa';
import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { useTranslations } from '@lang';
import { useQueryClient } from '@tanstack/react-query';
import { FC } from 'react';
import { InjectedFormProps } from 'redux-form';
import { SpaPackageBasketResolveType } from '../SpaPackageModal.types';
import { parseSpaPackageData } from './SubmitButton.helpers';
import { DispatchProps, StateProps, SubmitButtonProps } from './SubmitButton.types';

export type SubmitButtonConnectedProps = SubmitButtonProps & StateProps & DispatchProps;

export const SubmitButton: FC<
  SubmitButtonConnectedProps & InjectedFormProps<{}, SubmitButtonConnectedProps>
> = ({
  handleSubmit,
  entity,
  property,
  language,
  createBasket,
  updateBasket,
  currentBasketItems,
  disabled,
  closeModal,
  buttonTextId,
}) => {
  const { t } = useTranslations();
  const queryClient = useQueryClient();
  const isGroupedSpaBookingEnabled = useFeatureIsOn('spa-days-grouped-booking');

  const addToBasket = (logData) => {
    const parsedBasketItems = parseSpaPackageData(logData, entity, isGroupedSpaBookingEnabled);
    const promises: SpaPackageBasketResolveType[] = [];
    if (currentBasketItems.length) {
      const basketId = Cookie.get('basketId') as string;
      const items = [...currentBasketItems, ...parsedBasketItems];
      promises.push(
        updateBasket(
          property.id,
          basketId,
          language,
          {
            items,
          },
          false,
          true
        )
      );
    } else {
      const items = parsedBasketItems;
      promises.push(
        createBasket(
          property.id,
          language,
          {
            items,
          },
          true
        )
      );
    }
    Promise.any(promises).then(() => {
      invalidateSpaPackageTimeslots(queryClient);
      closeModal(true);
    });
  };

  return (
    <Button isPrimary onClick={handleSubmit(addToBasket)} disabled={disabled}>
      {buttonTextId ? t(buttonTextId) : t('product.ctaButton')}
    </Button>
  );
};
